import React from 'react'
import { Flex } from 'antd-mobile';
import store from '../../store/store'
import "./TopHome.scss"
import {} from "../../api/index"
export default class TopHome extends React.Component{
    constructor(props){
        super(props)
        this.state={
            userName:JSON.parse(sessionStorage.getItem("userInfo")),
            powerData:JSON.parse(sessionStorage.getItem("PORWE")),
        }
    }
    saveData(s){
        this.props.history.push({pathname:s.children[0].url});
        sessionStorage.setItem('tabArr', JSON.stringify(s.children));
    }
    render(){
        return (
            <div className="TopHome">
                <p  className="title">欢迎您</p>
                <span   className="username">{this.state.userName.realName}</span>
                <div className="cardWrap" >
                    {
                        this.state.powerData.map((s)=>{
                            return <div onClick={()=>{this.saveData(s)}}>
                                <i
                                    className={"icomoon iconfont  lresize "+s.icon}
                                    
                                />
                                <p>{s.name}</p>
                            </div>
                        })
                    }
                </div>
            </div>
        )
    }
    componentDidMount(){
        
    }
    
}